<template>
  <v-row v-if="showPagination" class="mb-4" justify="center" align="center">
    <v-col v-if="hasSizeSelection" shrink>
      <v-row align="center">
        <v-select
          class="select-size"
          ref="selectSize"
          v-model="size"
          :items="sizeOptions"
          solo
          hide-details
        ></v-select>
        <span class="font-regular grey--text text--darken-1 ml-2 mr-5">{{
          $t("basePagination.itemsPerPage")
        }}</span>
      </v-row>
    </v-col>
    <v-col shrink>
      <v-pagination
        v-model="page"
        :length="totalPages"
        :total-visible="7"
        class="pagination"
        ref="selectPage"
        prev-icon="fas fa-angle-left"
        next-icon="fas fa-angle-right"
      ></v-pagination>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    pageType: {
      type: String,
      required: false
    },
    storeType: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      sizeOptions: [5, 8, 25, 50]
    };
  },
  computed: {
    showPagination() {
      return this.hasPagination && this.totalPages > 1;
    },
    hasPagination() {
      return this.storeType == "newsTutorial";
    },
    hasSizeSelection() {
      return false;
    },
    page: {
      get() {
        return this.$store.getters[`${this.storeType}/page`];
      },
      set(page) {
        this.$store.commit(`${this.storeType}/updatePage`, page);
        this.$emit("retrieveitems", page);
      }
    },
    totalPages() {
      let totalItems = this.$store.getters[`${this.storeType}/totalItems`];
      return Math.ceil(totalItems / this.size);
    },
    size: {
      get() {
        return this.$store.getters[`${this.storeType}/size`];
      },
      set(value) {
        this.$refs.selectSize.blur();
        this.$store.commit(`${this.storeType}/updateSize`, value);
        this.$emit("retrieveitems");
      }
    }
  }
};
</script>

<style scoped>
.select-size >>> .v-input__control {
  min-height: 34px;
}
.select-size >>> .v-input__slot {
  width: 70px;
}

.pagination >>> .v-pagination__item,
.pagination >>> .v-pagination__navigation {
  box-shadow: unset;
  background: unset;
  width: auto;
  min-width: 20px;
  margin: 4px;
  padding: 0;
}

.pagination >>> .v-pagination__item {
  height: 24px;
}

.pagination >>> .v-pagination__navigation {
  height: 50px;
}

.pagination >>> .v-pagination__navigation .v-icon {
  color: var(--primary);
  font-size: 36px;
}
</style>
